import ReactGA from 'react-ga'

const ANALYTICS_TRACKING_ID = 'UA-72555763-19'

export const initGA = () => {
  ReactGA.initialize(ANALYTICS_TRACKING_ID)
}

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname })
  ReactGA.pageview(window.location.pathname)
}

export const logEvent = (category = '', action = '') => {
  if (category && action) {
    ReactGA.event({ category, action })
  }
}

export const logException = (description = '', fatal = false) => {
  if (description) {
    ReactGA.exception({ description, fatal })
  }
}



// WEBPACK FOOTER //
// ./utils/analytics.js